<script>
import { ref, markRaw, inject, nextTick, onMounted, onBeforeUnmount } from "vue";
import { Utilities, InjectionKeys } from "@vue-leaflet/vue-leaflet";
import "leaflet";
import "leaflet-routeboxer";
import "leaflet-routing-machine";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
const routingControlProps = {
  waypoints: {
    type: Array,
    default: () => []
  },
  fitSelectedRoutes: {
    type: [String, Boolean],
    default: true
  },
  draggableWaypoints: {
    type: Boolean,
    default: false
  },
  addWaypoints: {
    type: Boolean,
    default: false
  },
  lineOptions: {
    type: Object,
    default: void 0
  },
  autoRoute: {
    type: Boolean,
    default: true
  }
};
export default {
  name: "LeafletRoutingMachine",
  props: {
    ...routingControlProps,
    showDirections: {
      type: Boolean,
      default: false
    },
    routerToken: {
      type: String,
      default: ""
    }
  },
  setup(props, context) {
    const { UseGlobalLeafletInjection, RegisterControlInjection } = InjectionKeys;
    const { WINDOW_OR_GLOBAL, assertInject, propsBinder, remapEvents } = Utilities;
    const useGlobalLeaflet = inject(UseGlobalLeafletInjection);
    const registerControl = assertInject(RegisterControlInjection);
    const leafletObject = ref(null);
    const options = Utilities.propsToLeafletOptions(
      props,
      routingControlProps
    );
    onMounted(async () => {
      const { routing } = useGlobalLeaflet ? WINDOW_OR_GLOBAL.L : await import("leaflet/dist/leaflet-src.esm");
      options.router = new L.Routing.mapbox(props.routerToken, {
        routingOptions: {
          geometryOnly: true,
          alternatives: false,
          steps: false
        }
      });
      const { listeners } = remapEvents(context.attrs);
      leafletObject.value = markRaw(routing.control(options));
      leafletObject.value.on(listeners);
      leafletObject.value.on("routesfound", (e) => {
        const route = e.routes[0];
        const coordinates = route.coordinates;
        const boxes = L.RouteBoxer.box(coordinates, 10);
        const boxedNW = boxes.map(
          (box) => `${box.getNorthEast().lat};${box.getSouthWest().lng}`
        );
        const boxedSE = boxes.map(
          (box) => `${box.getSouthWest().lat};${box.getNorthEast().lng}`
        );
        context.emit("routeBoxes", { NW: boxedNW, SE: boxedSE });
      });
      propsBinder({}, leafletObject.value, props);
      registerControl({ leafletObject: leafletObject.value });
      nextTick(() => {
        if (!props.showDirections) {
          const container = leafletObject.value?._container;
          if (container && container.parentNode) {
            container.parentNode.removeChild(container);
          }
        }
        context.emit("ready", leafletObject.value);
      });
    });
    onBeforeUnmount(() => {
      if (leafletObject.value) {
        leafletObject.value.setWaypoints([]);
        leafletObject.value.remove();
      }
    });
  }
};
</script>

<template>

</template>
